import React, { useEffect } from 'react';
import { canIUse } from '../../helpers/PermissionUtility';
import { AppFeatures } from '../../helpers/PermissionUtility-types';
import loadable from '@loadable/component';
import RouteLoader from '../../components/RouteLoader';
import { useNavigate } from 'react-router-dom';
import { permanentRedirect } from '../helpers';

const Welcome = loadable(() => import('../../welcome/Welcome'), { fallback: <RouteLoader /> });

export default function HomeRedirect() {
  const navigate = useNavigate();
  const canUseDashboard = canIUse(AppFeatures.Dashboard);
  const redirect = permanentRedirect(navigate);

  useEffect(() => {
    if (!canUseDashboard) {
      redirect('/forms');
    }
  }, [canUseDashboard]);

  if (canUseDashboard) {
    return <Welcome />;
  }

  return null;
}
